<section class="event-landing-page">
  <div class="event-landing-page__shell">
    <p *ngIf="isLoading" class="event-landing-page__status" role="status">
      {{ rsvpStatusMessage || 'Loading event details…' }}
    </p>

    <section
      *ngIf="isUnavailable"
      class="event-landing-page__unavailable"
      aria-labelledby="event-unavailable-title"
    >
      <h1 id="event-unavailable-title">This event page is unavailable</h1>
      <p>The event may be unpublished, disabled, or no longer available.</p>
      <a class="btn btn-black" routerLink="/events">Browse events</a>
    </section>

    <app-event-landing-banner
      *ngIf="displayPage as visiblePage"
      [page]="visiblePage"
      [countdown]="countdown"
      [ctaMode]="ctaMode"
      [primaryLabel]="primaryCtaLabel"
      [statusMessage]="rsvpStatusMessage"
      [isWorking]="isRsvpWorking"
      [primaryDisabled]="isViewerStateLoading || eventCta === 'FULL'"
      [primaryUnavailable]="eventCta === 'FULL'"
      primaryUnavailableHint="This event has reached capacity."
      [showCancel]="showCancelRsvp"
      [showJoinNotice]="showJoinNotice"
      [watchNotice]="watchNotice"
      [showSecondaryAction]="showSecondaryRsvp"
      [secondaryLabel]="secondaryRsvpLabel"
      (share)="openShareModal()"
      (primaryAction)="onPrimaryAction()"
      (cancelAction)="onCancelRsvp()"
      (secondaryAction)="onSecondaryRsvp()"
    >
      <app-calendar-picker
        eventCalendarAction
        *ngIf="displayPage && canAddEventToCalendar"
        [eventId]="displayPage.eventId"
        [fullWidth]="true"
        [prominent]="showCancelRsvp"
      ></app-calendar-picker>
    </app-event-landing-banner>
  </div>
</section>

<div *ngIf="appRsvpUrl" class="event-app-choice-backdrop">
  <section class="event-app-choice" role="dialog" aria-modal="true" aria-labelledby="event-app-choice-title">
    <h2 id="event-app-choice-title">Continue to event</h2>
    <p>Open the event in the CitizeX app, or sign in here and RSVP on the event page. If the app doesn’t open, you can still continue in your browser.</p>
    <div class="event-app-choice__actions">
      <button type="button" class="btn btn-black" (click)="openRsvpInApp()">Open CitizeX app</button>
      <button type="button" class="btn event-app-choice__browser" (click)="continueRsvpInBrowser()">Continue in browser</button>
    </div>
    <button type="button" class="event-app-choice__cancel" (click)="appRsvpUrl = null" aria-label="Close">Cancel</button>
  </section>
</div>

<app-share-modal #shareModal [currentUrl]="canonicalUrl"></app-share-modal>
